import styled from 'styled-components';

export const OptionalText = styled.span`
  display: block;
`;

export const ConsentLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;
